'use strict'
import io from 'socket.io-client'
import store from '../store'
import getSocketParams from './getSocketParams'

export default (user) => {
    
    const socketParams = getSocketParams()
    let socket = io(socketParams.host + '/notify', { path: socketParams.path, transports : ['websocket'] , query:{companyUserId: user.EMPRESA_USUARIO_ID, token:`Bearer ${user.TOKEN}`}})
    socket.on('connect', () => {
        socket.emit('create', socket.id)
    })
    socket.on('notify', (data) =>{

        store.dispatch('notify', data)
    })
}